import {PanelBase} from "./panelBase";
import {Integrations} from "../integrations";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {IntegrationType} from "@/shared/timrTypes";

/*
 * Base class for the tiles of the workspace calendar integrations (Google, Microsoft, ...).
 * They all show their logo next to a text label, open the integration page of their provider and can be removed.
 */
export abstract class WorkspaceCalendarPanel extends PanelBase {

	protected abstract get integrationType(): IntegrationType;

	/*
	 * The URL of the integration page of this provider. Empty as long as no workspace integration is configured
	 * for the environment, in which case no open action is offered.
	 */
	protected abstract get integrationUrl(): string;

	private connectedCallback() {
		// The logo and the label are named after the integration type, so a provider whose calendar is marketed under a
		// different name than its account (MICROSOFT -> "Outlook") carries that name in its asset and messages.
		const name = messages[this.messageCode("name")];
		this.innerHTML = this.renderPanel({
			logoHtml: `
				<div class="display-flex flex-valign-middle">
					<img src="/timr/images/integrations/${this.integrationType.toLowerCase()}.svg" alt="${name}" height="36px">
					<span class="ml-10 mt-0 mb-0 h1">${name}</span>
				</div>
			`,
			topActionsHtml: this.integrationUrl ? this.renderEditActionButton("open", this.messageCode("open")) : ""
		});
		this.initListeners();
	}

	private initListeners() {
		$(this).find("#open").on("click", () => this.openIntegration());
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages[this.messageCode("delete.message")],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(this.integrationType, this.integration.id);
				}
			});
		});
	}

	protected updateBanner(): void {
		// Nothing to do here
	}

	public onIntegrationAdded() {
		this.openIntegration();
	}

	private openIntegration() {
		if (!this.integrationUrl) {
			return;
		}
		// Open in new tab/window -> browser preference
		window.open(this.integrationUrl, "_blank", "noreferrer");
	}

	private messageCode(suffix: string): string {
		return `integrations.${this.integrationType.toLowerCase()}.${suffix}`;
	}
}
